export default __webpack_public_path__ + "static/media/annotation_arrow.b9765c71.svg";